import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';

export interface IBillingModuleModel {
    SelectedTabIndex: number;
    ListData: ListData<any>;
}

@Component({
    selector: 'fi-billing-header',
    templateUrl: './billing-header.component.html',
    styleUrls: ['./billing-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-header' },
    standalone: false,
})
export class BillingHeaderComponent extends TabsModuleBase implements OnInit {
    @Input('billingModuleModel') BillingModuleModel: IBillingModuleModel;

    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector, { replaceLocation: true });
    }

    ngOnInit() {
        this.tabs = [
            {
                Title: this.appTextService.get('billing.unit_administration'),
                Sref: FiStateNames.Billing.Unit.List,
            },
            {
                Title: this.appTextService.get('billing.payment'),
                Sref: FiStateNames.Billing.Payment.List,
            },
            {
                Title: this.appTextService.get('billing.company_information'),
                Sref: FiStateNames.Billing.CompanyInformation.List,
            },
        ];

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Billing.Central.List)) {
            this.tabs.unshift({
                Title: this.appTextService.get('billing.central_billing_admin'),
                Sref: FiStateNames.Billing.Central.List,
            });
        }

        super.updateSelectedTabFromState();
    }
}
